import React, { useState, useEffect } from "react";
import config from "../../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { exportToExcel } from "react-json-to-excel";

const ExcelTaxList = (props) => {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [listOfLedger, setLedger] = useState([]);
  const [selectedYear, setselectedYear] = useState("");
  const [selectedMonth, setselectedMonth] = useState("");

  useEffect(() => {
    document.title = "Employee Tax List";

    setLoading(true);
    // Get the URL parameters
    setselectedYear(props.year);
    setselectedMonth(props.Month);


    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      Fyear: props.year,
      SelectedMonth: props.month,
      EmployeeTypeId: props.EmployeeTypeId,
      PayScale: props.PayScale,
    };

    // console.log(data);
    var api_config = {
      method: "post",
      url: config.base_url + "Payroll/GetTaxList",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    console.log(data);

    axios(api_config)
      .then(function (response) {
        let data = response.data.ListofRecords;
        const listOfEmployeeData = data.map(({ ...item }, index) => ({
          SrNo: index + 1,
          Code: item.SelectedEmployee?.Code,
          Staff_Name: item.SelectedEmployee?.Name,
          Father_Name: item.SelectedEmployee?.Father_Name,
          Designation: item.SelectedEmployee?.SelectedDesignation?.Name,
          Account_No: item.SelectedEmployee?.Account_No,
          BPS: item.SelectedEmployee?.GPS_Scale, // BPS corresponds to GPS_Scale
          CNIC_No: item.SelectedEmployee?.CNIC_NO,
          Gross: item.Gross,
          Tax_Paid: item.Tax,
          Mobile_No: item.SelectedEmployee?.Mobile_No,
        }));

        setLedger(listOfEmployeeData);

        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);



  return (
    <>
      <button disabled={loading} className="button button-primary-outline excel-button" onClick={() => exportToExcel(listOfLedger, 'Manage Enquiry List')}>
        {loading ? <Spinner /> : <i className="ri-file-excel-2-line"></i>}
      </button>
    </>
  );
};

export default ExcelTaxList;
